// HEADER-DOCS-024: single source of truth for the SMS plan gate.
//
// Product rule (confirmed 2026-10-08):
//   - Chat TEXT between Student <-> Counselor/Parent is allowed on every plan.
//   - SMS sync of chat messages ("In-App Messaging SMS") is a paid feature.
//   - The plan that matters is always the STUDENT's plan in the conversation.
//
// Plans currently sold (screen/payment/components): GradMap Starter (free),
// Silver Plus (month/year), Gold (month/year). The legacy Silver plan is no
// longer sold, so it is intentionally NOT in the allow-list.

import { STRIPE_PRICE_NAME } from 'constants/common';

/** Subscription plans (`subcription_plan` from the backend) that include SMS. */
export const SMS_PAID_PLANS: readonly string[] = [
  STRIPE_PRICE_NAME.SilverPlusMonth,
  STRIPE_PRICE_NAME.SilverPlusYear,
  STRIPE_PRICE_NAME.GoldMonth,
  STRIPE_PRICE_NAME.GoldYear,
];

/** Display name of the cheapest plan that unlocks SMS (used on the lock chip). */
export const SMS_MIN_PLAN_LABEL = 'Silver Plus';

/**
 * True when the given student plan includes SMS sync.
 * Empty / unknown / GradMap Starter / legacy Silver → false.
 */
export const canUseSms = (plan?: string | null): boolean =>
  Boolean(plan) && SMS_PAID_PLANS.includes(plan as string);
